module.exports = __webpack_public_path__ + "img/folder2.5e57366f.svg";